<template>
    <div id="change-device" v-if="isSuperAdmin">
        <div class="button-set">
            <div class="base-button neutral large" :class="{ pressed: showDesktop }" @click="selectDesktop()">
                <LaBaseIcon :name="'monitor'" />
                desktop
            </div>
            <div class="base-button neutral large" :class="{ pressed: showMobile }" @click="selectMobile()">
                <LaBaseIcon :name="'cellphone'" />
                mobile
            </div>
            <div class="base-button neutral large" :class="{ pressed: showMobile == showDesktop }" @click="selectAll()">
                all
            </div>
        </div>
    </div>
</template>

<script>
import LaBaseIcon from "@/components/BaseIcon.vue";
import { ref, computed } from "vue";
import store from "@/store/store";
import { getterTypes } from "@/store/LoggedUser/types";

export default {
    name: "ChangeDevice",
    components: {
        // LaBaseCard,
        LaBaseIcon,
    },
    props: {},
    emits: ["deviceChange"],
    setup(props, { emit }) {
        const userRights = computed(() => store.getters[getterTypes.getUserRights]);
        const isSuperAdmin = computed(() => userRights.value && userRights.value["super_admin"]);

        let showDesktop = ref(true);
        let showMobile = ref(false);

        const getDevice = () => {
            if (showMobile.value == showDesktop.value) {
                return "";
            }
            if (showMobile.value) {
                return "mobile";
            }
            return "desktop";
        };

        const selectMobile = () => {
            if (!showMobile.value) {
                showMobile.value = true;
                showDesktop.value = false;
            } else {
                showMobile.value = false;
            }
            emit("deviceChange", getDevice());
        };
        const selectDesktop = () => {
            if (!showDesktop.value) {
                showDesktop.value = true;
                showMobile.value = false;
            } else {
                showDesktop.value = false;
            }
            emit("deviceChange", getDevice());
        };
        const selectAll = () => {
            showDesktop.value = false;
            showMobile.value = false;

            emit("deviceChange", getDevice());
        };
        return {
            selectMobile,
            selectDesktop,
            selectAll,
            showMobile,
            showDesktop,
            isSuperAdmin,
        };
    },
};
</script>

<style scoped lang="scss">
#change-device {
    line-height: 1;
    margin-right: 1rem;
    margin-left: 1rem;
    margin-top: -0.25rem;
}

body.light #change-device {
    line-height: 1;
    margin-right: 1rem;
    margin-left: 1rem;
    margin-top: -0.25rem;

    .base-button {
        &.neutral {
            background: white linear-gradient(180deg, #fdfdfd, #f5f5f5) repeat-x !important;
            border: 1px solid #e8e8e8 !important;
            color: #333 !important;
            padding-top: 0.7rem;
            padding-bottom: 0.8rem;

            &:hover {
                background: #f8f8f8 !important;
                color: #000 !important;
            }

            &.pressed {
                background: #f0f0f0 linear-gradient(180deg, #ebebeb, #e5e5e5) repeat-x !important;
                box-shadow: inset 2px 2px 4px rgba(0, 0, 0, 0.15) !important;
                color: #333 !important;
                border-color: #ccc !important;
            }
        }
    }

    .button-set .base-button {
        border-right: 1px solid #e8e8e8 !important;
    }
}

body.variant-performax #change-device {
    margin-top: 0.75rem;
}

body.dark #change-device {
    .base-button {
        &.neutral {
            background: linear-gradient(159deg, #262a13 3.01%, #424731 103.3%);
            border: 1px #000;
            color: #fff;

            &:hover {
                background: linear-gradient(159deg, #121409 3.01%, #1f2117 103.3%);
            }

            &.pressed {
                background: linear-gradient(159deg, #121409 3.01%, #1f2117 103.3%);
                box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.25), inset -1px -2px 2px rgba(255, 255, 255, 0.25);
                color: #a6ad8a;
            }
        }
    }
}
</style>
